import { Theme } from "@mui/material"
import { useTheme } from "@mui/system"

export interface BackgroundProps {
    offset: number
}


export const TiledBackground = (props: BackgroundProps) => {
    const theme = useTheme<Theme>()

    const divStyle: React.CSSProperties = {
        top: "-5px",
        backgroundPosition: `0px ${-props.offset}px`,
        left: "-5px",
        backgroundImage: theme.bee.backgroundImage,
        backgroundBlendMode: theme.bee.backgroundBlendMode,
        backgroundSize: theme.bee.backgroundSize,
        opacity: theme.bee.backgroundOpacity,
        width: "100%",
        height: "100%",
        position: "absolute",
        padding: "0",
        zIndex: -100,
    }

    return (
        <div style={divStyle}></div>
    )
}